// extracted by mini-css-extract-plugin
export default {"logo":"Footer_logo__B7si-","wrp":"Footer_wrp__3FPCl","items":"Footer_items__a427U","footer_btm":"Footer_footer_btm__gb0zv"};